import { Container, Button, Form } from 'reactstrap';
import { SavedQueryList, CustomerList, StatusList,RepList, SectionList, TeamList,SizeList, ColTypeList, SiteList, PubList} from './FormComponents';
import { ZIndexContext} from '@progress/kendo-react-common';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Switch, SwitchChangeEvent, TextBox, TextBoxChangeEvent, TextBoxHandle } from '@progress/kendo-react-inputs';
import React, { ChangeEvent, FormEvent, useState, useContext, useEffect, useRef } from 'react';
import type { ColTypeEntry, salesRep, SearchFields,SiteEntry } from '../services/interfaces';
import { PageContext } from './PageContext';
import { UserContext } from './UserContext';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { getSavedQueries } from '../services/apiService';
//import {userProfile} from '../validate';
//import { GetSavedQueries } from './lists';


//const user = userProfile();

//const savedQueries = GetSavedQueries();
interface SearchFormProps {
    toggleSearch: () => void;
    setFields:(fields:SearchFields)=>void;
    fields:string
  }



interface SavedQuery{
    query_Num:number,
    query_Name:string,
    sqL_Query_1000:string,
    query_Owner:string
}



export default function SearchForm({toggleSearch, setFields, fields}:SearchFormProps){
    const [formData, setFormData] = useState<SearchFields>({
        archive:false,
        proofOnly:false,
        omitSpec:false,
        omitNewAd:false,
        adNum:"",
        status: [],
        statusMatch:"1",
        customer:undefined,
        account:"",
        salesRep:[],
        color:"Select color",
        adType:"Ad type",
        section:[],
        team:[],
        size:"",
        colType:[],
        site:[],
        publication:[],
        whiteGlove:{text:"White Glove", value:""},
        tagline:"",
        dateType:{ text: "Any run date", value: "0" },
        fixedDate:{text: "Select date", value: "" },
        fixedDay:"",
        startDay:{text: "Start Day", value: "" },
        endDay:{text: "End Day", value: "" },
        startDate:"",
        endDate:"",
        allGroup:false,
        groupName:"",
        queryName:"",
        queryIsGlobal:false,
        savedQueries:"",
        issue:""
    })
    const pageContext = useContext(PageContext);
    const userContext=useContext(UserContext);
    const [query, setQuery] = useState<SavedQuery>();
    const [showFixedDay, setShowFixedDay] = useState(false);
    const [showFixedDate, setShowFixedDate] = useState(false);
    const [showQueryName, setShowQueryName]=useState(false);
    const [statLabel,setStatLabel]=useState("Status is:")
    const adNumberRef = useRef<TextBoxHandle>(null);
    //const [selCustomer,setSelCustomer]=useState({customer:"", fileSize2:"", file1:""});

    function setSearchStatus(stat:string[]){
        //console.log("Selected:" + stat);
        setFormData({...formData,status:stat});        
    }
    function setSearchCustomer(cust:{customer:string, fileSize2:string, file1:string}){
        console.log(cust);
        setFormData({...formData,customer:cust});        

        //setSelCustomer(cust);
    }
    function setSearchRep(rep:salesRep[]){
        
        setFormData({...formData,salesRep:rep});        
    }
    function setSearchAdNum(event:TextBoxChangeEvent){
        setFormData({...formData,adNum:String(event.target.value)});
    }



    function setQueryName(event:TextBoxChangeEvent){
        setFormData({...formData,queryName:String(event.target.value)});
    }
    function setSearchAccount(event:TextBoxChangeEvent){
        setFormData({...formData,account:String(event.target.value)});
    }
    function setQueryIsGlobal(event:ChangeEvent<HTMLInputElement>){
        setFormData({...formData,queryIsGlobal:(event.target.checked)});
    }

    function setStatusIs(statusIs: SwitchChangeEvent){
        //console.log(statusIs);
        if (statusIs.value===true){
            setFormData({...formData,statusMatch:"1"});            
        }else{
            setFormData({...formData,statusMatch:"0"});
        }
    }

    function getStatusIs(){
        //console.log("statusMatch:"+formData.statusMatch);
        if (formData.statusMatch=="1"){
            return true;
        }else{
            return false;
        }
    }
    function setSearchSection(section:string[]){
        setFormData({...formData,section:section});
    }
    function setSearchTeam(team:string[]){
        setFormData({...formData,team:team});
    }

    function setSearchSize(size:string){
        setFormData({...formData,size:size});
    }
    

    function setSearchColor(color:DropDownListChangeEvent){
        setFormData({...formData, color:color.target.value});
    }
    
    function setSearchAdType(type:DropDownListChangeEvent){
        setFormData({...formData, adType:type.target.value});
    }

    function setSearchWhiteGlove(glove:DropDownListChangeEvent){
        setFormData({...formData, whiteGlove:glove.value});
    }

    function setSearchColType(colType:ColTypeEntry[]){
        setFormData({...formData,colType:colType});
    }

    function setSearchSite(site:SiteEntry[]){
        //console.log(site);
        setFormData({...formData,site:site});
    }

    function setSearchPub(pub:string[]){
        setFormData({...formData,publication:pub});
    }
    function setSearchTagline(event:TextBoxChangeEvent){
        setFormData({...formData,tagline:String(event.target.value)});
    }
    function setSearchDateType(glove:DropDownListChangeEvent){
        setFormData({...formData, dateType:glove.target.value});
    }
    function showDaySelector(show:boolean){
        setShowFixedDay(show);
    }
    function showDateSelector(show:boolean){
        setShowFixedDate(show);
    }

    function setSearchArchive(check:ChangeEvent<HTMLInputElement>){
        setFormData({...formData,archive:check.target.checked});
    }

    function setSearchProofOnly(check:ChangeEvent<HTMLInputElement>){
        setFormData({...formData,proofOnly:check.target.checked});
    }
    function setSearchOmitSpec(check:ChangeEvent<HTMLInputElement>){
        setFormData({...formData,omitSpec:check.target.checked});
    }

    function setSearchOmitNew(check:ChangeEvent<HTMLInputElement>){
        setFormData({...formData,omitNewAd:check.target.checked});
    }

    function showQueryNameField(check:ChangeEvent<HTMLInputElement>){
        setShowQueryName(check.target.checked);
    }

    function setSearchFixedDate(date:DropDownListChangeEvent){
        console.log("SetSearchFixedDate fired");
        switch (date.target.value.value){
             case "10":
        //         //console.log("Show Day Selectors");
                 showDateSelector(false);
                 showDaySelector(true);
                 break;
             case "11":
        //         //console.log("Show Date Selectors");
                 showDateSelector(true);
                 showDaySelector(false);
                 break;
             default:
                 showDateSelector(false);
                 showDaySelector(false);
                break;
         }
        setFormData({...formData, fixedDate:date.target.value});
    }

    
    
    function checkSearchFixedDate(){
        //console.log("CheckSearchFixedDate fired");
        //console.log(formData);
        
        switch (formData.fixedDate.value){
           case "10":
               //console.log("Show Day Selectors");
               showDateSelector(false);
               showDaySelector(true);
               break;
           case "11":
               //console.log("Show Date Selectors");
               showDateSelector(true);
               showDaySelector(false);
               break;
           default:
               showDateSelector(false);
               showDaySelector(false);
               break;
        }
        return (formData.fixedDate);
    }

    function setSearchStartDay(day:DropDownListChangeEvent){
        console.log(day);
        setFormData({...formData, startDay:day.target.value});
    }
    function setSearchEndDay(day:DropDownListChangeEvent){
        console.log(day);
        setFormData({...formData, endDay:day.target.value});
    }
    function setSearchStartDate(date:DatePickerChangeEvent){
        console.log(date.value);
        setFormData({...formData, startDate:date.target.value?.toLocaleDateString("en-us", { 
            month: '2-digit', 
            day: '2-digit',
            year: 'numeric' 
        })||""});
    }
    function setSearchEndDate(date:DatePickerChangeEvent){
        console.log(date.value);
        setFormData({...formData, endDate:date.target.value?.toLocaleDateString("en-us",{ 
            month: '2-digit', 
            day: '2-digit',
            year: 'numeric' 
        })||""});
    }

    function getWHiteGloveValue(setting:string){
        var retVal ={text:"",value:""};
        switch(setting){
            case "IWG":
                retVal= ({text:"Ignore", value:"IWG"});
                break;
            case "WGO":
                retVal= ({text:"White Glove Only", value:"WGO"})
                break;
            case "EWG":
                retVal= ({text:"Exclude White Glove", value:"EWG"})
                break;
        }
        setFormData({...formData, whiteGlove:retVal});
    }

    function setSavedQuery(query:SavedQuery){
        setQuery(query);
    }

    function resetFormData(){
        setFormData({
            archive:false,
            proofOnly:false,
            omitSpec:false,
            omitNewAd:false,
            adNum:"",
            status: [],
            statusMatch:"1",
            customer:undefined,
            account:"",
            salesRep:[],
            color:"Select color",
            adType:"Ad type",
            section:[],
            team:[],
            size:"",
            colType:[],
            site:[],
            publication:[],
            whiteGlove:{text:"White Glove", value:""},
            tagline:"",
            dateType:{ text: "Any run date", value: "0" },
            fixedDate:{text: "Select date", value: "" },
            fixedDay:"",
            startDay:{text: "Start day", value: "" },
            endDay:{text: "End day", value: "" },
            startDate:"",
            endDate:"",
            allGroup:false,
            groupName:"",
            queryName:"",
            queryIsGlobal:false,
            savedQueries:"",
            issue:""
        }); 
    }



    function clearSearch(){
        const clearData:SearchFields=
        {
            archive:false,
            proofOnly:false,
            omitSpec:false,
            omitNewAd:false,
            adNum:"",
            status: [],
            statusMatch:"1",
            customer:undefined,
            account:"",
            salesRep:[],
            color:"Select color",
            adType:"Ad type",
            section:[],
            team:[],
            size:"",
            colType:[],
            site:[],
            publication:[],
            whiteGlove:{text:"White Glove", value:""},
            tagline:"",
            dateType:{ text: "Any run date", value: "0" },
            fixedDate:{text: "Select date", value: "" },
            fixedDay:"",
            startDay:{text: "Start Day", value: "" },
            endDay:{text: "End Day", value: "" },
            startDate:"",
            endDate:"",
            allGroup:false,
            groupName:"",
            queryName:"",
            queryIsGlobal:false,
            savedQueries:"",
            issue:""
        }; 
        setFormData(clearData);
        setFields(clearData);
    }
    
    function submitSearch(e: FormEvent): void {
        e.preventDefault();
        //console.log(formData);
        setFields(formData);
        toggleSearch();
        if (userContext?.user.trafficUser==false){
            pageContext?.setSelectedTab(5);
        }else{
            pageContext?.setSelectedTab(3);
        }
    }

    const [moreExpanded, setMoreExpanded] = useState(false);
    function expandCollapseMore(){

        if (formData.archive||formData.proofOnly||formData.omitSpec||formData.omitNewAd){
            console.log("Show More Options");
            setMoreExpanded(true);
        }else{
            setMoreExpanded(false);
        }        
    }

    const parseQuery=()=>{
        const jQuery = JSON.parse(query?.sqL_Query_1000 || '{}');
        console.log(jQuery);
        var sFields:SearchFields={
            archive:false,
            proofOnly:false,
            omitSpec:false,
            omitNewAd:false,
            adNum:"",
            status: [],
            statusMatch:"1",
            customer:undefined,
            account:"",
            salesRep:[],
            color:"Select color",
            adType:"Ad type",
            section:[],
            team:[],
            size:"",
            colType:[],
            site:[],
            publication:[],
            whiteGlove:{text:"White Glove", value:""},
            tagline:"",
            dateType:{ text: "Any run date", value: "0" },
            fixedDate:{text: "Select date", value: "" },
            fixedDay:"",
            startDay:{text: "Start day", value: "" },
            endDay:{text: "End day", value: "" },
            startDate:"",
            endDate:"",
            allGroup:false,
            groupName:"",
            queryName:"",
            queryIsGlobal:false,
            savedQueries:"",
            issue:""
        };

        Object.keys(jQuery).forEach(function(key){
            switch (key){
                case "archive":
                    if (jQuery[key]==true||jQuery[key]=="True"){
                        sFields.archive=true;
                    }
                    break;
                case "proofonly":
                case "proofOnly":
                    if (jQuery[key]==true||jQuery[key]=="True"){
                        sFields.proofOnly=true;
                    }
                    break;
                case "omitSpec":
                    if (jQuery[key]==true||jQuery[key]=="True"){
                        sFields.omitSpec=true;
                    }
                    break;
                case "omitNewAd":
                    if (jQuery[key]==true||jQuery[key]=="True"){
                        sFields.omitNewAd=true;
                    }
                    break;
                case "adNumber":
                    if (jQuery[key] != null) {                   
                        sFields.adNum=jQuery[key];
                    }
                    break;
                case "issue":
                    if (jQuery[key] != null) {
                    sFields.issue=jQuery[key];
                    }
                    break;
                case "customer":
                    if (jQuery[key] != null) {
                        sFields.account=jQuery[key];
                    }
                    break;
                case "account":
                    if (jQuery[key] != null) {
                        sFields.account=jQuery[key]
                    };
                    break;
                case "status":
                    if (jQuery[key] != null) {
                        var aStatus: Array<string> = [];
                        if (jQuery[key].includes(",")){
                            aStatus = jQuery[key].split(",");
                            sFields.status=aStatus;
                        }else{
                            aStatus = [];
                            aStatus.push(jQuery[key]);
                            sFields.status=aStatus;
                        }
                    }
                    break;
                case "statusMatch":
                    if (jQuery[key]=="1"){
                        sFields.statusMatch="0";
                    }else{
                        sFields.statusMatch="1";
                    }
                    //sFields.statusMatch=jQuery[key];
                    break;
                case "salesRep":
                    if (jQuery[key]!=null){
                        var aSalesRep:Array<string>=[];
                        if (jQuery[key].includes(",")){
                            aSalesRep = jQuery[key].split(",");
                            console.log(aSalesRep);
                            sFields.salesRep = aSalesRep.map(rep => ({
                                displayName:"",
                                fullName:"",
                                customer:rep,
                                security:1,
                                temp4:""
                            } as salesRep));
                        }else{
                            aSalesRep = [];
                            aSalesRep.push(jQuery[key]);
                            sFields.salesRep=aSalesRep.map(rep => ({ 
                                displayName:"",
                                fullName:"",
                                customer:rep,
                                security:1,
                                temp4:"" } as salesRep));
                        }
                    }
                    break;
                case "section":
                    if (jQuery[key]!=null){
                        var aSection:Array<string>=[];
                        if (jQuery[key].includes(",")){
                            aSection = jQuery[key].split(",");
                            sFields.section=aSection;
                        }else{
                            aSection = [];
                            aSection.push(jQuery[key]);
                            sFields.section=aSection;
                        }
                    }                    
                    break;
                case "team":
                    if (jQuery[key]!=null){
                        var aTeam:Array<string>=[];
                        if (jQuery[key].includes(",")){
                            aTeam = jQuery[key].split(",");
                            sFields.team=aTeam;
                        }else{
                            aTeam = [];
                            aTeam.push(jQuery[key]);
                            sFields.team=aTeam;
                        }
                    }                    
                    break;
                case "color":
                    if (jQuery[key] != null) {
                        if (jQuery[key]!="Select color"){
                            if (jQuery[key]=="1"){
                                sFields.color="COLOR";
                            }else{
                                sFields.color="BLACK & WHITE";
                            }
                            //sFields.color=jQuery[key]
                        }else{
                            sFields.color=""
                        }
                    };
                    break;
                case "adType":
                    if (jQuery[key] != null) {
                        if (jQuery[key]!="Ad Type"){
                            if (jQuery[key]=="DA"){
                                sFields.adType="PRINT";
                            }else{
                                sFields.adType="ONLINE";
                            }
                            //sFields.adType=jQuery[key];
                        }else{
                            sFields.adType="";
                        }
                    }
                    break;
                case "size":
                    if (jQuery[key] != null) {
                        sFields.size=jQuery[key];
                    }
                    break;
                case "colType":
                    if (jQuery[key]!=null){
                        var aColType:Array<ColTypeEntry>=[];
                        if (jQuery[key].includes(",")){
                            aColType  = jQuery[key].split(",");
                            sFields.colType=aColType;
                        }else{
                            aColType = [];
                            aColType.push(jQuery[key]);
                            sFields.colType=aColType;
                        }
                    }                    
                    break;
                case "publication":
                    if (jQuery[key]!=null){
                        var aPub:Array<string>=[];
                        if (jQuery[key].includes(",")){
                            aPub = jQuery[key].split(",");
                            sFields.publication=aPub;
                        }else{
                            aPub = [];
                            aPub.push(jQuery[key]);
                            sFields.publication=aPub;
                        }
                    }                    
                    break;
                case "site":
                    if (jQuery[key]!=null){
                        var aSite:Array<SiteEntry>=[];
                        if (jQuery[key].includes(",")){
                            aSite = jQuery[key].split(",");
                            sFields.site=aSite;
                        }else{
                            aSite = [];
                            aSite.push(jQuery[key]);
                            sFields.site=aSite;
                        }
                    }                                  
                    break;
                case "whiteGlove":
                    if (jQuery[key] != null) { 
                        var retVal ={text:"",value:""};
                        switch(jQuery[key]){
                            case "IWG":
                                retVal= ({text:"Ignore", value:"IWG"});
                                break;
                            case "WGO":
                                retVal= ({text:"White Glove Only", value:"WGO"})
                                break;
                            case "EWG":
                                retVal= ({text:"Exclude White Glove", value:"EWG"})
                                break;
                        }
                        sFields.whiteGlove=retVal;
                    }
                    break;
                case "dateType":
                    if (jQuery[key] != null) {
                        switch(jQuery[key]){
                            case 0:
                            case "0":
                                sFields.dateType={ text: "Any run date", value: "0" };
                                break;
                            case 1:
                            case "1":
                                sFields.dateType={ text: "First run date", value: "1" };
                                break;
                            case 2:
                            case "2":
                                sFields.dateType={ text: "Next run date", value: "2" };
                                break;
                            case 3:
                            case "3":
                                sFields.dateType={ text: "Current Deadline", value: "3" };
                                break;
                            case 4:
                            case "4":
                                sFields.dateType={ text: "Pagination Deadline", value: "4" };
                                break;
                            case 5:
                            case "5":
                                sFields.dateType={ text: "Pagination Actual", value: "5" };
                                break;
                            case 6:
                            case "6":
                                sFields.dateType={ text: "Material In Deadline", value: "6" };
                                break;
                            case 7:
                            case "7":
                                sFields.dateType={ text: "Material In Actual", value: "7" };
                                break;
                            case 8:
                            case "8":
                                sFields.dateType={ text: "Proof Out Deadline", value: "8" };
                                break;
                            case 9:
                            case "9":
                                sFields.dateType={ text: "Proof Out Actual", value: "9" };
                                break;
                            case 10:
                            case "10":
                                sFields.dateType={ text: "Corrections Deadline", value: "10" };
                                break;
                            case 11:
                            case "11":
                                sFields.dateType={ text: "Corrections Actual", value: "11" };
                                break;
                            default:
                                sFields.fixedDate=jQuery[key];
                        }                       
                    }
                    break;
                case "fixedDate":
                    if (jQuery[key] != null) {
                        switch(jQuery[key]){
                            case 1:
                            case "1":
                                sFields.fixedDate={ text: "Today", value: "1" };
                                break;
                            case 2:
                            case "2":
                                sFields.fixedDate={ text: "Tomorrow", value: "2" };
                                 break;
                            case 3:
                            case "3":
                                sFields.fixedDate={ text: "Yesterday", value: "3" };
                                 break;
                            case 4:
                            case "4":
                                sFields.fixedDate={ text: "This Week", value: "4" };
                                 break;
                            case 5:
                            case "5":
                                sFields.fixedDate={ text: "This month", value: "5" };
                                 break;
                            case 6:
                            case "6":
                                sFields.fixedDate={ text: "This Year", value: "6" };
                                 break;
                            case 7:
                            case "7":
                                sFields.fixedDate={ text: "Last Week", value: "7" };
                                 break;
                            case 8:
                            case "8":
                                sFields.fixedDate={ text: "Last month", value: "8" };
                                 break;
                            case 9:
                            case "9":
                                sFields.fixedDate={ text: "Last Year", value: "9" };
                                break;
                            case 12:
                            case "12":
                                sFields.fixedDate={ text: "Next Week", value: "12" };
                                break;
                            case 13:
                            case "13":
                                sFields.fixedDate={ text: "Next Month", value: "13" };
                                break;
                            case 14:
                            case "14":
                                sFields.fixedDate={ text: "Two Weeks Out", value: "14" };
                                break;
                            case 10:
                            case "10":
                                sFields.fixedDate={ text: "Day Range", value: "10" };
                                 break;
                            case 11:
                            case "11":
                                sFields.fixedDate={ text: "Date Range", value: "11" };
                                break;
                        }
                        //sFields.fixedDate=jQuery[key];
                    }
                    break;
                case "fixedDay":
                    if (jQuery[key] != null) {
                        sFields.fixedDay=jQuery[key];
                    }
                    break;
                case "startDay":
                    if (jQuery[key] != null) {
                        sFields.startDay=jQuery[key];
                    }
                    break;
                case "endDay":
                    if (jQuery[key] != null) {
                        sFields.endDay=jQuery[key];
                    }
                    break;
                case "startDate":
                    if (jQuery[key] != null) {
                        sFields.startDate=jQuery[key];
                    }
                    break;
                case "endDate":
                    if (jQuery[key] != null) {
                        sFields.endDate=jQuery[key];
                    }
                    break;
                case "tagLine":
                    if (jQuery[key] != null) {
                        sFields.tagline=jQuery[key];
                    }
                    break;
                case "allGroup":
                    if (jQuery[key]==true){
                        sFields.allGroup=true;
                    }
                    break;
                case "groupName":
                    if (jQuery[key] != null) {
                        sFields.groupName=jQuery[key];
                    }
                    break;
            }
        });
        setFormData(sFields);
        console.log (sFields);
    }
    
    const setSelectedCustomer=()=>{
        
        if (formData.customer && formData.customer?.customer!=""){
            //setSelCustomer(formData.customer);
        }
    }

    // useEffect(()=>{
    //     setFormData({...formData,customer:selCustomer.fileSize2});        
    // },[selCustomer])

    useEffect(()=>{
        if (formData.statusMatch=="1"){
            setStatLabel("Status is: ");
        }else{
            setStatLabel("Status is not: ");
        }
    },[formData.statusMatch])

    useEffect(()=>{
        console.log(formData);
        checkSearchFixedDate();
        //setSelectedCustomer();
    },[formData]);

    useEffect(()=>{
        parseQuery();
    },[query]);

    useEffect(() => {
        console.log("Search Form Use Effect");
        if (fields){
            var fieldVals: SearchFields = JSON.parse(fields);

            //parseFields();
            setFormData(fieldVals);

        }
    }, []);
    
    useEffect(()=>{
        if (adNumberRef.current?.element) {
          adNumberRef.current.element.focus();
        }
    },[]);  
    
    return (
        <div>
            <form id="searchForm" typeof='POST' onSubmit={submitSearch}>
            
            <Container className='formField' >
            <Button color="primary" type="submit">
                Search
            </Button>
            &nbsp;
            <Button onClick={clearSearch}>
                Clear
            </Button>
            </Container>
            <Container>
                <ZIndexContext.Provider value={1060}>
                    <SavedQueryList setSavedQuery={setSavedQuery} value={query || { query_Num: 0, query_Name: '', sqL_Query_1000: '', query_Owner: '' }}/>
                    <div className='formField'>
                        <input type="checkbox" id="sfSaveQuery" onChange={showQueryNameField} checked={showQueryName}/>&nbsp;
                        <label htmlFor="sfArchive">Save this query</label>
                    </div>
                     <div className='formField'>
                        <input type="checkbox" id="sfArchive" onChange={setSearchArchive} checked={formData.archive}/>&nbsp;
                        <label htmlFor="sfArchive">Include archived Ads</label>
                    </div>
                    {showQueryName?
                        <>
                        <TextBox className='formField' value={formData.queryName} placeholder={"Enter Query Name"} onChange={setQueryName}/>                                                        
                        {userContext?.user.type==5? <div className='formField'><input type="checkbox" id="sfGlobalQuery" onChange={setQueryIsGlobal} checked={formData.queryIsGlobal}/>&nbsp;<label htmlFor="sfOmitNsfGlobalQueryewAd">Make this a global query</label></div>:null}
                        </>
                    :null}
                    <PanelBar className='formField'>
                        <PanelBarItem title="More Options" expanded={moreExpanded} selected={moreExpanded}>
                           
                            <div>
                                <input type="checkbox" id="sfProofOnly" onChange={setSearchProofOnly} checked={formData.proofOnly}/>&nbsp;
                                <label htmlFor="sfProofOnly">Only ads with proofs</label>
                            </div>
                            <div>
                                <input type="checkbox" id="sfOmitSpec" onChange={setSearchOmitSpec} checked={formData.omitSpec}/>&nbsp;
                                <label htmlFor="sfOmitSpec">Omit spec ads</label>
                            </div>
                            <div>
                                <input type="checkbox" id="sfOmitNewAd" onChange={setSearchOmitNew} checked={formData.omitNewAd}/>&nbsp;
                                <label htmlFor="sfOmitNewAd">Omit manual ad orders</label>
                            </div>
                            {userContext?.user.trafficUser==true?
                            <div>
                                <input type="checkbox" id="sfAllGroup"/>&nbsp;
                                <label htmlFor="sfAllGroup">Search all ads in group</label>
                            </div>
                            :null}
                        </PanelBarItem>
                    </PanelBar>
                    <TextBox className='formField' placeholder="Ad Number" name="sfAdNum" ref={adNumberRef} value={formData.adNum} onChange={setSearchAdNum}/>
                    <CustomerList value={formData.customer} setReturnAction={setSearchCustomer} site="" valid={true} allowNew={false}/>
                    <TextBox className='formField' placeholder="Account Number" name="sfAccount" value={formData.account} onChange={setSearchAccount}/>
                    <div className='formField'>{statLabel}&nbsp;<Switch defaultChecked={true} onChange={setStatusIs} onLabel={"Is"} offLabel={"Not"} checked={getStatusIs()} /></div>
                    <StatusList value={formData.status||[]} setStatus={setSearchStatus} type="multi" enabled={true}/>
                    <RepList value={formData.salesRep||[]} setReturnAction={setSearchRep} multi={true} site="" valid={true}/>
                    <div className='formField'><DropDownList id="sfColor" data={["BLACK & WHITE","COLOR"]} onChange={setSearchColor} fillMode={"outline"} defaultItem={"Select color"} value={formData.color||""}/></div>
                    <div className='formField'><DropDownList id="sfAdType" data={["PRINT","ONLINE"]} onChange={setSearchAdType} fillMode={"outline"} defaultItem={"Ad type"} value={formData.adType||""}/></div>
                    <SizeList value={formData.size||''} setSearchSize={setSearchSize}/>
                    <SectionList value={formData.section||[]} setSearchSection={setSearchSection}/>
                    <TeamList value={formData.team||[]} setSearchTeam={setSearchTeam}/>
                    <ColTypeList value={formData.colType||""} setReturnAction={setSearchColType} multi={true} valid={true}site={{ code:"",name:"",logo_Prefix:"",primary_ip:"",backup_ip:"",temp_Char:"",temp_Int:"",vol1_Unc_Path:"",vol2_Unc_Path:""}} adType=''/>
                    <SiteList value={formData.site} setReturnAction={setSearchSite} multi={true} valid={true} className='formField'/>
                    <PubList value={formData.publication||""} setReturnAction={setSearchPub} type='multi' archiveOnly={false} liveOnly={true} siteFilter='' className='formField' returnField='num' onlineOnly={false} printOnly={false}/>
                    <div className='formField'><DropDownList id="sfWhiteGlove" data={[{text:"Ignore", value:"IWG"},{text:"White Glove Only", value:"WGO"},{text:"Exclude White Glove", value:"EWG"}]} textField='text' dataItemKey='value' value={formData.whiteGlove} onChange={setSearchWhiteGlove} fillMode={"outline"} defaultItem={{text:"White Glove"}}/></div>
                    <TextBox className='formField' placeholder="Tagline" name="sfTagline" value={formData.tagline} onChange={setSearchTagline}/>
                    <div className='formField'>
                        <DropDownList id="sfDateType" 
                        data={[
                            { text: "Any run date", value: "0" },
                            { text: "First run date", value: "1" },
                            { text: "Next run date", value: "2" },
                            { text: "Current Deadline", value: "3" },
                            { text: "Pagination Deadline", value: "4" },
                            { text: "Pagination Actual", value: "5" },
                            { text: "Material In Deadline", value: "6" },
                            { text: "Material In Actual", value: "7" },
                            { text: "Proof Out Deadline", value: "8" },
                            { text: "Proof Out Actual", value: "9" },
                            { text: "Corrections Deadline", value: "10" },
                            { text: "Corrections Actual", value: "11" },
                        ]}
                        textField='text' 
                        dataItemKey='value' 
                        onChange={setSearchDateType} fillMode={"outline"} defaultItem={ { text: "Any run date", value: "0" }} value={formData.dateType}/>
                    </div>
                    <div className='formField'>
                        <DropDownList id="sfFixedDate" 
                        data={[
                            { text: "Today", value: "1" },
                            { text: "Tomorrow", value: "2" },
                            { text: "Yesterday", value: "3" },
                            { text: "This Week", value: "4" },
                            { text: "This month", value: "5" },
                            { text: "This Year", value: "6" },
                            { text: "Last Week", value: "7" },
                            { text: "Last month", value: "8" },
                            { text: "Last Year", value: "9" },
                            { text: "Next Week", value: "12" },
                            { text: "Next Month", value: "13" },
                            { text: "Two Weeks Out", value: "14" },
                            { text: "Two Days Out", value: "20" },
                            { text: "Day Range", value: "10" },
                            { text: "Date Range", value: "11" }
                        ]}
                        textField='text' 
                        dataItemKey='value' 
                        onChange={setSearchFixedDate} fillMode={"outline"} defaultItem={ { text: "Select date", value: "" }} value={formData.fixedDate}/>
                    </div>
                    {showFixedDay?  
                    <>                  
                    <div className='formField'>
                        <DropDownList id="sfStartDay" 
                        data={[
                            { text: "Sunday", value: "0" },
                            { text: "Monday", value: "1" },
                            { text: "Tuesday", value: "2" },
                            { text: "Wednesday", value: "3" },
                            { text: "Thursday", value: "4" },
                            { text: "Friday", value: "5" },
                            { text: "Saturday", value: "6" }
                        ]}
                        textField='text' 
                        dataItemKey='value' 
                        onChange={setSearchStartDay} fillMode={"outline"} defaultItem={ { text: "Start day", value: "" }} value={formData.startDay}/>
                    </div>
                    <div className='formField'>
                        <DropDownList id="sfEndDay" 
                        data={[
                            { text: "Sunday", value: "0" },
                            { text: "Monday", value: "1" },
                            { text: "Tuesday", value: "2" },
                            { text: "Wednesday", value: "3" },
                            { text: "Thursday", value: "4" },
                            { text: "Friday", value: "5" },
                            { text: "Saturday", value: "6" }
                        ]}
                        textField='text' 
                        dataItemKey='value' 
                        onChange={setSearchEndDay} fillMode={"outline"} defaultItem={ { text: "End day", value: "" }} value={formData.endDay}/>
                    </div>
                    </>
                    : null}
                    {showFixedDate? 
                    <>
                    <div className='formField'>
                        <DatePicker placeholder={"Start Date"} onChange={setSearchStartDate} fillMode={"outline"} value={formData.startDate!=""? new Date(formData.startDate):null}/>                        
                    </div>
                    <div className='formField'>
                        <DatePicker placeholder={"End Date"} onChange={setSearchEndDate} fillMode={"outline"} value={formData.endDate!=""? new Date(formData.endDate):null}/>                        
                    </div>
                    
                    </> : null}
                </ZIndexContext.Provider>
            </Container>
            </form>
        </div>
    );
};


